import { BASE_URL } from '../configs/config';

export const getRiderMapByIds = async (riderIds: string[]): Promise<Record<string, string>> => {
  try {
    const res = await fetch(`${BASE_URL}get_riders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ rider_ids: riderIds }),
    });

    const data = await res.json();
    const map: Record<string, string> = {};
    data.forEach((r: any) => {
      map[r.id] = r.name || r.email;
    });
    return map;
  } catch (error) {
    console.error('Error fetching riders:', error);
    return {};
  }
};
